import React from "react";

export const MUGSHOT_LOGO_PATH = "/Mugshot.png";

export function resolveMugshotProBillingCycle(tx = {}) {
  const explicit = String(tx.mugshotProBillingCycle || tx.billingCycle || "")
    .trim()
    .toLowerCase();

  if (explicit === "yearly" || explicit === "annual" || explicit === "year") return "yearly";
  if (explicit === "monthly" || explicit === "month") return "monthly";

  return "unknown";
}

export function formatMugshotProSubscriptionSubline(tx = {}, language = "de") {
  const cycle = resolveMugshotProBillingCycle(tx);

  if (cycle === "yearly") {
    return language === "de"
      ? "Pro-Jahresabo"
      : "Pro Yearly Subscription";
  }

  if (cycle === "monthly") {
    return language === "de"
      ? "Pro-Monatsabo"
      : "Pro Monthly Subscription";
  }

  return language === "de" ? "Pro-Abo" : "Pro Subscription";
}

export default function MugshotProSubscriptionTypeLabel({
  tx,
  language = "de",
  leading = null,
  titleClassName = "text-gray-800 font-normal",
  subtitleClassName = "text-[11px] font-medium text-gray-700/90",
}) {
  const subline = formatMugshotProSubscriptionSubline(tx, language);

  return (
    <div className={`flex items-start gap-2 min-w-0 ${titleClassName}`}>
      {leading != null ? (
        <span className="mt-0.5 shrink-0" aria-hidden>
          {leading}
        </span>
      ) : null}

      <img
        src={MUGSHOT_LOGO_PATH}
        alt="Mugshot"
        className="h-5 w-5 object-cover flex-shrink-0 mt-0.5 rounded-[22%] ring-1 ring-slate-200/70"
        draggable={false}
        onError={(e) => {
          e.currentTarget.style.display = "none";
        }}
      />

      <div className="min-w-0 leading-tight">
        <div className="whitespace-normal break-words">Mugshot</div>
        <div className={`whitespace-normal break-words ${subtitleClassName}`}>
          {subline}
        </div>
      </div>
    </div>
  );
}
